module.exports = __webpack_public_path__ + "static/media/r1.4cb780a2.jpg";